// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__bxFsr","row":"Node_row__3Bw_c","label":"Node_label__t0RAO","footer":"Node_footer__32xpC"};